var _defs, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920.08 1092.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#407bd3;}.cls-3{fill:#bbdcfc;}.cls-4{fill:#6baef2;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 960.08,
    y1: 1043.01,
    x2: 960.08,
    y2: -502.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbdcfc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.08,
    width: 1920,
    height: 1080
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1919.73,541.27v502.25H1045.82s11.5-21.12,33-55c8.4-13.25,18.33-28.46,29.68-45.11,14.62-21.46,31.61-45.32,50.78-70.52C1309.58,675.18,1594.1,394.35,1919.73,541.27Z",
    transform: "translate(0.08)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1140.81,850.06v242.13h-179L-.08,1043.52V969.76c61.76,18.4,127.88,30.86,191.32,29.29,79.33-2,154.46-25.87,211.64-87.57.57-.62,1.15-1.24,1.73-1.84,25.37-27,54.67-49.64,86.71-68.42C669.53,736.76,932.39,752.36,1074,811.56,1101.24,823,1124,836,1140.81,850.06Z",
    transform: "translate(0.08)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1919.73,942.21V1092H0L-.08,888.62s328.52-202.33,491.4-37.1c15.49,15.72,29.48,34.75,41.55,57.6C648.5,1128,945.43,913,1042,834.48a109.16,109.16,0,0,1,32-18.21,99,99,0,0,1,39.41-5.77c23.4,1.36,55.87,3.39,94.59,6.23C1408.36,831.41,1776.09,867.61,1919.73,942.21Z",
    transform: "translate(0.08)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 280.39,
    y: 777.91,
    width: 6.72,
    height: 27.2,
    rx: 3.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.43,773.69c0-8.28-20.06-49.69-26.76-49.69s-26.77,41.41-26.77,49.69,20.06,5.87,26.77,5.87S310.43,782,310.43,773.69Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1051.29,
    y: 802.89,
    width: 12.87,
    height: 37.11,
    rx: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 1055.85,
    cy: 786.22,
    rx: 22.77,
    ry: 30.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 972.81,
    y: 879.59,
    width: 4.63,
    height: 25.2,
    rx: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M994.54,861.7c0,9-9.66,20.52-19.49,20.52s-17.8-7.33-17.8-16.37.5-25.85,10.33-25.85S994.54,852.66,994.54,861.7Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 417.55,
    y: 821.03,
    width: 10,
    height: 18.07,
    rx: 3.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.21,825.72c0,5.63-20.94,2.09-29.64,2.09S389,827.29,389,821.67,417.1,773,425.79,773,455.21,820.1,455.21,825.72Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.84,821a9.78,9.78,0,0,1-9.64,9.92c-5.33,0-20.73,4-20.73-1.49s15.4-18.34,20.73-18.34A9.78,9.78,0,0,1,426.84,821Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.39,831c0,5.47-13,.86-18.36.86s-9.17-4.46-9.64-9.91c-.42-5,4.54-15.59,10.8-16.66C434.44,804.42,446.39,825.55,446.39,831Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225.87,
    y: 841.33,
    width: 7.17,
    height: 20.67,
    rx: 3.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 228.4,
    cy: 832.05,
    rx: 12.68,
    ry: 16.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1137.31,
    y: 903.17,
    width: 15.54,
    height: 28.08,
    rx: 5.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1195.87,910.46c0,8.74-32.54,3.24-46.06,3.24s-56.81-.81-56.81-9.54,43.65-75.61,57.16-75.61S1195.87,901.73,1195.87,910.46Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1151.78,903.07a15.19,15.19,0,0,1-15,15.4c-8.28,0-32.21,6.19-32.21-2.31s23.93-28.49,32.21-28.49A15.19,15.19,0,0,1,1151.78,903.07Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1182.16,918.69c0,8.5-20.24,1.34-28.51,1.34s-14.26-6.93-15-15.4c-.66-7.75,7-24.22,16.77-25.88C1163.59,877.36,1182.16,910.19,1182.16,918.69Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1673.77,
    y: 475.17,
    width: 18.86,
    height: 34.09,
    rx: 5.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1744.87,484c0,10.6-39.5,3.92-55.91,3.92s-69-1-69-11.58,53-91.78,69.39-91.78S1744.87,473.41,1744.87,484Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1691.35,475a18.44,18.44,0,0,1-18.18,18.69c-10,0-39.09,7.52-39.09-2.8s29.05-34.58,39.09-34.58A18.44,18.44,0,0,1,1691.35,475Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1728.22,494c0,10.33-24.56,1.62-34.61,1.62s-17.3-8.4-18.17-18.69c-.8-9.41,8.55-29.39,20.35-31.41C1705.69,443.83,1728.22,483.68,1728.22,494Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1616.32,
    y: 973.94,
    width: 7.24,
    height: 29.32,
    rx: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1648.71,969.39c0-8.93-21.62-53.57-28.85-53.57S1591,960.46,1591,969.39s21.62,6.32,28.86,6.32S1648.71,978.31,1648.71,969.39Z",
    transform: "translate(0.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1561.2,
    y: 913.7,
    width: 4.82,
    height: 26.24,
    rx: 2.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1583.82,895.08c0,9.4-10.06,21.36-20.29,21.36s-18.53-7.63-18.53-17,.52-26.91,10.75-26.91S1583.82,885.67,1583.82,895.08Z",
    transform: "translate(0.08)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.58e7f58b1ee0a869469fca09befad4ee.svg";
export { ForwardRef as ReactComponent };